module.exports = __webpack_public_path__ + "img/apidoc.7c7657e4.svg";